import { render, staticRenderFns } from "./DepositInfo.vue?vue&type=template&id=7239ea25&"
import script from "./DepositInfo.vue?vue&type=script&lang=js&"
export * from "./DepositInfo.vue?vue&type=script&lang=js&"
import style0 from "./DepositInfo.vue?vue&type=style&index=0&id=7239ea25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports